import { Component, OnInit,Input  } from '@angular/core';
import * as d3 from "d3";

import * as topojson from 'topojson';
import * as $ from 'jquery';
import { PublicReportService } from '../../modules/services/public-report.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-heatmap-bubble',
  templateUrl: './heatmap-bubble.component.html',
  styleUrls: ['./heatmap-bubble.component.scss']
})
export class HeatmapBubbleComponent implements OnInit {
  width = 500;
  height = 600;
  todaysdate: any;
  VaccData: any;
  bubbleData: any;
  states: any
  // statename1;
  @Input() statename = '';
  constructor(private publicReportService: PublicReportService,
    public datepipe: DatePipe) { }

  ngOnInit(): void {

    this.todaysdate = new Date();
    this.todaysdate = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
    const width = 100;
    const height = 400;
    this.publicReportService.getPublicReports('', '', this.todaysdate).subscribe((res: any) => {
      if (res) {
        this.VaccData = res.getBeneficiariesGroupBy;
        console.log("this.VaccData ", this.VaccData.length)
        const totalVac = this.VaccData.reduce((sum: number, v: any) => {
          return sum + parseInt(v.total);
        }, 0)

        this.bubbleData = this.VaccData.map((vacc: any) => {
          return {
            total: vacc.total,
          }

        });

        Promise.all([
          d3.json('../../../assets/json/states.json'),
          d3.json('../../../assets/json/sample.json')


        ]).then(([data1, data2]) => {
          // const countries = topojson.feature(data1, data1.objects.states);

          this.drawBubbleMap(data1, this.VaccData);


        }).catch(err => console.log('checkong d3 map'))
      } else {

      }

    });

    if (!this.VaccData) {
      Promise.all([
        d3.json('../../../assets/json/states.json'),
        d3.json('../../../assets/json/sample.json')


      ]).then(([data1, data2]) => {
        // const countries = topojson.feature(data1, data1.objects.states);

        // this.drawEmptyMap(data1);


      }).catch(err => console.log('checkong d3 map'))
    }

  }

  drawBubbleMap(world: any, data: any) {
    console.log('Registration component', this.statename);
    // console.log("w",this.width )
    const svg = d3.select('#my_dataviz1').append('svg')

      .attr('width', this.width).attr('height', this.height);

    const projection = d3.geoMercator().scale(100)
      .translate([this.width / 2, this.height / 1]);

    const path: any = d3.geoPath(null);

    var populationById: any = {};

    data.forEach(function (d: any) {
      populationById[d.state_name] = {

        total: +d.today,
        tot_total: +d.total,
        totally_vaccinated: d.totally_vaccinated,
        dose1: d.partial_vaccinated,
        dose2: d.totally_vaccinated,
        precaution_dose:d.precaution_dose
      }
    });


    const color = d3.scaleOrdinal()
      .domain(data.map((d: any) => d.state_name))
      .range(d3.schemePaired);

    var features: any = topojson.feature(world, world.objects.states);



    features.features.forEach(function (d: any) {

      d.details = populationById[d.properties.st_nm] ? populationById[d.properties.st_nm] : {};

    });

    //  console.log('Registration component', this.statename);
    // ---------------------Image--------------------------


    // ------------------------Draw Map---------------
    // console.log(" this.statename1", this.statename)
    if (this.statename == "Andaman and Nicobar Islands") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {

          if (d.id == "Andaman and Nicobar Islands") {
            return "#AEA1FF";//on condition match
          } else {
            return "#A8B8E2";
          }
        }).attr("d", path)
    } else if (this.statename == "Andhra Pradesh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {

          if (d.id == "Andhra Pradesh") {
            return "#AEA1FF";//on condition match
          } else {
            return "#A8B8E2";
          }
        }).attr("d", path)
    }
    else if (this.statename == "Arunachal Pradesh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {

          if (d.id == "Arunachal Pradesh") {
            return "#AEA1FF";//on condition match
          } else {
            return "#A8B8E2";
          }
        }).attr("d", path)
    }
    else if (this.statename == "Assam") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Assam") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Bihar") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Bihar") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Chandigarh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Chandigarh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Chhattisgarh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Chhattisgarh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Dadra and Nagar Haveli") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Dadra and Nagar Haveli") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Daman and Diu") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Daman and Diu") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Delhi") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Delhi") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Goa") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Goa") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Gujarat") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Gujarat") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Haryana") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Haryana") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Himachal Pradesh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Himachal Pradesh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Jammu and Kashmir") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Jammu and Kashmir") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Jharkhand") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Jharkhand") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Karnataka") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Karnataka") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Kerala") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Kerala") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Karnataka") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Kerala") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Ladakh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Ladakh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Lakshadweep") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Lakshadweep") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Madhya Pradesh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Madhya Pradesh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else if (this.statename == "Maharashtra") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Maharashtra") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else if (this.statename == "Manipur") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Manipur") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else if (this.statename == "Meghalaya") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Meghalaya") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else if (this.statename == "Mizoram") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Mizoram") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Nagaland") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Nagaland") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Odisha") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Odisha") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Puducherry") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Puducherry") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Punjab") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Punjab") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Rajasthan") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Rajasthan") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Sikkim") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Sikkim") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Tamil Nadu") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Tamil Nadu") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Telangana") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Telangana") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Tripura") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Tripura") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else if (this.statename == "Uttar Pradesh") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Uttar Pradesh") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "Uttarakhand") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "Uttarakhand") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }
    else if (this.statename == "West Bengal") {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .style("fill", function (d) {
          if (d.id == "West Bengal") {
            return "#AEA1FF";//on condition match

          } else {
            return "#A8B8E2";
          }


        }).attr("d", path)
    }

    else {
      svg.selectAll('path').data(features.features).enter().append('path').
        attr('class', 'state').attr('d', path)
        .style("fill", "#A8B8E2")
        .style(" fill-opacity", ".2")
        .style("stroke", "#FFFFFF")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("id", function (d: any) {
          return d.id;
        })
        .attr("d", path)

    }

    // ------------------Tooltip--------------------

    var tooltip =
      d3.select("body")
        .append("div")
        .style("position", "absolute")
        .style("z-index", "1")
        .style("visibility", "visible")
        .style("cursor", "default")
        .attr("class", "map_tooltip")
        .style("left", (100) + "px")
        .style("top", (200) + "px")
        .style("background", "white");
        
    var div = d3.select("body").append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    var radius = d3.scaleSqrt()
      // .domain([0, 500000])
      .domain([0, 70000000])
      .range([0, 10]);


    // --------------Add Bubbles------------------
  
  // else{
      svg.append("g")
      .attr("class", "bubble")
      .selectAll("circle")
      .data(features.features)
      .enter().append("circle")
      .attr("transform", function (d: any) {
        // console.log("check", d)
        return "translate(" + path.centroid(d) + ")";
      })
     
      .attr("r", 14)
      .attr("r", function (d: any) { return radius(d.details.tot_total) })
      .style("fill", "#5439FC")
    
      .attr("stroke", function (d: any) {
        if (d.details.tot_total > 0) { return "#5439FC" } else { return "none" }
      })
      .attr("stroke-width", 15)
      .attr('stroke-opacity', .5)
      // .attr("fill-opacity", .5)
      .on('mousemove', function (event, d: any) {
        // console.log("mouse", d)
        d3.select(this)

        tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
          '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
          '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
          '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
          '</span>')
          .style("left", (event.pageX + 50) + "px")
          .style("top", (event.pageY - 30) + "px")
          //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
          .style("cursor", "default")

      })
      .on("mouseover ", function (d) {
        tooltip.style("opacity", 1)
      })
      .on("mouseleave", function (d) {
        tooltip.style("opacity", 0)
      })
  //  }
  if(this.statename == "Andaman and Nicobar Islands"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
   
      if (d.id == "Andaman and Nicobar Islands") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Andaman and Nicobar Islands") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Andaman and Nicobar Islands") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Andhra Pradesh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
   
      if (d.id == "Andhra Pradesh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Andhra Pradesh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Andhra Pradesh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Arunachal Pradesh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
    
      if (d.id == "Arunachal Pradesh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Arunachal Pradesh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Arunachal Pradesh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Assam"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Assam") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Assam") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Assam") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Bihar"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Bihar") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Bihar") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Bihar") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Chandigarh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Chandigarh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Chandigarh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Chandigarh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Chhattisgarh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Chhattisgarh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Chhattisgarh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Chhattisgarh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Dadra and Nagar Haveli"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
  
      if (d.id == "Dadra and Nagar Haveli") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Dadra and Nagar Haveli") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Dadra and Nagar Haveli") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }

   if(this.statename == "Daman and Diu"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Daman and Diu") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Daman and Diu") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Daman and Diu") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Delhi"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Delhi") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Delhi") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Delhi") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Goa"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Goa") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Goa") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Goa") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Gujarat"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Gujarat") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Gujarat") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Gujarat") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Haryana"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Haryana") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Haryana") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Haryana") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Himachal Pradesh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Himachal Pradesh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Himachal Pradesh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Himachal Pradesh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Jammu and Kashmir"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Jammu and Kashmir") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Jammu and Kashmir") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Jammu and Kashmir") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Jharkhand"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Jharkhand") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Jharkhand") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Jharkhand") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Karnataka"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Karnataka") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Karnataka") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Karnataka") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }

   if(this.statename == "Kerala"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Kerala") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Kerala") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Kerala") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   
   if(this.statename == "Ladakh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Ladakh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Ladakh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Ladakh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   
   if(this.statename == "Lakshadweep"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Lakshadweep") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Lakshadweep") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Lakshadweep") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   
   if(this.statename == "Madhya Pradesh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Madhya Pradesh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Madhya Pradesh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Madhya Pradesh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   
   if(this.statename == "Maharashtra"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Maharashtra") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Maharashtra") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Maharashtra") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   
   if(this.statename == "Manipur"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Manipur") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Manipur") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Manipur") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Meghalaya"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Meghalaya") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Meghalaya") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Meghalaya") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Mizoram"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Mizoram") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Mizoram") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Mizoram") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Nagaland"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Nagaland") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Nagaland") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Nagaland") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Odisha"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Odisha") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Odisha") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Odisha") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Puducherry"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Puducherry") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Puducherry") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Puducherry") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Punjab"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Punjab") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Punjab") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Punjab") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Rajasthan"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Rajasthan") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Rajasthan") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Rajasthan") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Sikkim"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Sikkim") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Sikkim") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Sikkim") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Tamil Nadu"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Tamil Nadu") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Tamil Nadu") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Tamil Nadu") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Telangana"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Telangana") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Telangana") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Telangana") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Tripura"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Tripura") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Tripura") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Tripura") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Uttar Pradesh"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Uttar Pradesh") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Uttar Pradesh") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Uttar Pradesh") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "Uttarakhand"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "Uttarakhand") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "Uttarakhand") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "Uttarakhand") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
   if(this.statename == "West Bengal"){
    // features.features= features.features.filter(e => e.state_name == this.statename);
    svg.append("g")
    .attr("class", "bubble")
    .selectAll("circle")
    .data(features.features)
    .enter().append("circle")
    .attr("transform", function (d: any) {
      console.log("check", d)
      if (d.id == "West Bengal") {
      return "translate(" + path.centroid(d) + ")";
      }
    })
    .attr("r", 14)
    .attr("r", function (d: any) {
      if (d.id == "West Bengal") {
       return radius(d.details.tot_total) 
      }
      
      })
    .style("fill", function (d) {
      if (d.id == "West Bengal") {
        return '#1C2039';//on condition match

      } 
    })
  
    .attr("stroke", function (d: any) {
      if (d.details.tot_total > 0) { return '#1C2039'} else { return "none" }
    })
    .attr("stroke-width", 15)
    .attr('stroke-opacity', .5)
    .on('mousemove', function (event, d: any) {
      // console.log("mouse", d)
      d3.select(this)

      tooltip.html('<b style=font-size:12px> ' + d.id + '</b> ' +
        '<br> <span style=font-size:12px><span style=color:#D4D4D4>Dose One</span> '+'<br>  <b>' + d.details.dose1.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Dose Two</span> ' + '<br> <b>' + d.details.dose2.toLocaleString('en-IN') + '</b>' +
        '<br/><span style=font-size:12px><span style=color:#D4D4D4>Precaution Dose</span> ' + '<br> <b>' + d.details.precaution_dose.toLocaleString('en-IN') + '</b>' +
        '</span>')
        .style("left", (event.pageX + 50) + "px")
        .style("top", (event.pageY - 30) + "px")
        //  d3.select("tooltip").html("<i>"+(d.id + " : " + d.details.total)+"<i>")
        .style("cursor", "default")

    })
    .on("mouseover ", function (d) {
      tooltip.style("opacity", 1)
    })
    .on("mouseleave", function (d) {
      tooltip.style("opacity", 0)
    })
    
   }
  
     
    // ------------legend------------

    var radius1 = d3.scaleSqrt()
      .domain([0, 1e6])
      .range([0, 15]);

    const xCircle = 40
    const xLabel = 90

    const valueExtent = d3.extent(data, (d: any) => +d.total)
    console.log("valueExtent", valueExtent)
    var size = d3.scaleSqrt()
      .domain([1, 100])  // What's in the data
      .range([1, 500])  // Size in pixel

    var legend = svg.append("g")
      .attr("class", "legend")
      // .attr("transform", "translate(" + (this.width - 90) + "," + (this.height - 50) + ")")
      // .attr("transform", "translate(" + (400) + "," + (490) + ")")
      .attr("transform", "translate(" + (1) + "," + (545) + ")")
      .selectAll("g")
      // .data([10000, 500000, 10000000])
      .data([1e6, 3e6, 6e6])

      .enter().append("g");

    legend.append("circle")
      .attr("cx", xCircle)
      .attr("cy", function (d) { return -radius1(d); })
      // .attr("cy", function(d){ 

      //   return this.height - size(d) } )
      .attr("r", function (d) { return size(d) })
      .style("fill", "none")
      .attr("stroke", "#A8B8E2")


      .attr("r", function (d) {
        console.log("r", d)
        return radius1(d)
      });

    legend.append("text")
      .attr("y", function (d) {

        return -2 * radius1(d);
      })
      .attr("dy", "1.5em")
      .attr("dx", "3.6em")
      .style("font", "10px sans-serif")
      .style("text-anchor", "middle")
      .style("text-color", "white")
      .style("fill", "#A8B8E2")
      .text(d3.format(".1s"));


  }

  drawEmptyMap(world: any) {
    console.log(world)
    const svg = d3.select('#my_dataviz1').append('svg')

      .attr('width', this.width).attr('height', this.height);
    const path: any = d3.geoPath(null);
    var features: any = topojson.feature(world, world.objects.states);
    svg.selectAll('path').data(features.features).enter().append('path').
      attr('class', 'state').attr('d', path)
      .style("fill", "#A8B8E2")
      .style("stroke", "#FFFFFF")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 600 400")
      .attr("id", function (d: any) {
        // console.log("dh", d)
        return d.id;
      })


      .attr("d", path)
  }
  getStatename(state = "") {
    this.statename = state;
    console.log("this.statename ", this.statename)
    this.publicReportService.getPublicReports('', '', this.todaysdate).subscribe((res: any) => {
      if (res) {
        this.VaccData = res.getBeneficiariesGroupBy;
        console.log("this.VaccData ", this.VaccData.length)
        const totalVac = this.VaccData.reduce((sum: number, v: any) => {
          return sum + parseInt(v.total);
        }, 0)

        this.bubbleData = this.VaccData.map((vacc: any) => {
          return {
            total: vacc.total,
          }

        });

        Promise.all([
          d3.json('../../../assets/json/states.json'),
          d3.json('../../../assets/json/sample.json')


        ]).then(([data1, data2]) => {
          // const countries = topojson.feature(data1, data1.objects.states);

          this.drawBubbleMap(data1, this.VaccData);


        }).catch(err => console.log('checkong d3 map'))
      } else {

      }

    });
  }


}
